import styled from 'styled-components';

export const MismatchAlert = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 12px;
  padding: 12px 16px;
  border: 1px solid #F87171;
  border-left-width: 4px;
  border-radius: 8px;
  background: #FEF2F2;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #303030;
`;
